import { useEffect, useState } from 'react';

export function useLocalStorageBoolean(key: string): boolean {
  const [value, setValue] = useState(() => localStorage.getItem(key) === 'true');

  useEffect(() => {
    const onStorage = () => {
      setValue(localStorage.getItem(key) === 'true');
    };

    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener('storage', onStorage);
    };
  }, [key]);

  return value;
}
